module.exports = __webpack_public_path__ + "media/images/emblems/Pont-la-Ville-coat_of_arms-5755e560986ac0aa5ace43f5fbcdfa22.svg";